export var CAN_EXTERNAL_APPLY = {
  INVALID_NUM: 0,
  CAN_APPLY: 1,
  CANT_APPLY: 2
};
//# sourceMappingURL=corp-share-auth-info.js.map